// extracted by mini-css-extract-plugin
export default {"faqSectionWrapper":"FAQSection_faqSectionWrapper__1exqZ","faqSectionContent":"FAQSection_faqSectionContent__L7zSy"};